// extracted by mini-css-extract-plugin
export default {"desktop":"desktop__2WhpG","mobile":"mobile__2PO6T","list":"list__12-rh"};